import React, { useState, useEffect } from 'react';
import { IconLock, IconLockOpen, IconExclamationTriangle } from '../../../../ui-kit/icons';
import { Card } from '../../../../ui-kit';

const IncidentSelector = ({
  locked,
  displayableIncidents,
  displayedIncident,
  setDisplayedIncidentId,
  toggleLock,
  displayNextIncident
}) => {
  const [counter, setCounter] = useState(10);

  useEffect(() => {
    const counterInterval = setInterval(() => {
      const newCounter = locked ? counter : counter - 1;
      counter - 1 <= 0 ? displayNextIncident() : setCounter(newCounter);
    }, 1000);

    return () => clearInterval(counterInterval);
  }, [counter, locked]);

  useEffect(() => {
    setCounter(10);
  }, [displayedIncident?.id]);

  return (
    <Card className="position-fixed end-0 bottom-0 mb-2 me-3">
      <Card.Body>
        <h3 className="mb-0">
          {locked || `${I18n.t('dashboards.widget_archetypes.shared.next_incident_message')} ${counter}`}
          {displayableIncidents.map(incident => (
            <span className="ms-3" onClick={() => setDisplayedIncidentId(incident.id)} key={incident.id}>
              <IconExclamationTriangle className={incident.id === displayedIncident.id ? 'text-danger' : ''} />
            </span>
          ))}
          <span className="ms-3" onClick={toggleLock}>
            {locked && <IconLock fixedWidth />}
            {locked || <IconLockOpen fixedWidth />}
          </span>
        </h3>
      </Card.Body>
    </Card>
  );
};

export default IncidentSelector;
